import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UnsavedChangesService {
  hasUnsavedChanges = false;

  setUnsavedChanges(value: boolean): void {
    this.hasUnsavedChanges = value;
  }

  canLeave(): boolean {
    return !this.hasUnsavedChanges;
  }
}